import { openDrawer } from "@/src/components/dialogs";

import { Button } from "@/src/components/buttons";
import { Card, CompartmentCard } from "@/src/components/cards";
import { Copyable } from "@/src/components/copyableTextComponent";
import { FetchableList } from "@/src/components/fetchableLists";
import SearchBar from "@/src/components/searchBar";
import { Reference } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getUserId, uid } from "@/src/utils/utils";
import { useState } from "react";
import { ReferenceForm } from "./referenceForm";
import { openAiReferenceForm } from "./aiReferenceForm";

function AdminFormulaires() {
  let [searchKey, setSearchKey] = useState("");

  const [reload, setReload] = useState(0);

  async function openFormulaireDialog(formulaire: Reference) {
    console.log("the formulaire", formulaire);
    await openDrawer({
      id: "formulaireDialog",
      title: "Formulaire",

      content: (
        <ReferenceForm
          current={formulaire}
          categories={["formulaire"]}
          onChange={(newValue) => {
            formulaire = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let inserted = await apiFetch("references", "addOne", {
          reference: formulaire,
        });
        setReload((prev) => prev + 1);
      },
    });
  }

  return (
    <CompartmentCard
      title={"Formulaires"}
      searchKey={searchKey}
      onSearch={(newValue) => {
        setSearchKey(newValue || "");
      }}
      onClick={async () => {
        let formulaire: Reference = {
          sections: [],
          name: `Reference `,
          creator: getUserId(),
          category: "formulaire",
        };
        await openFormulaireDialog(formulaire);
      }}
      secondaryButtonTitle={"Générer un formulaire par IA"}
      onSecondaryClick={async () => {
        await openAiReferenceForm({
          currentCategory: "formulaire",
          allowedCategoriesIds: ["formulaire"],
          currentPrompt: ``,
          onSave: async (reference) => {
            setReload((prev) => prev + 1);
            await openFormulaireDialog(reference);
          },
        });
      }}
    >
      <FetchableList
        queryKey={["AdminFormulaires", searchKey, reload]}
        queryFn={() =>
          apiFetch("references", "loadMany", {
            userId: getUserId(),
            searchKey,
            categoriesIds: ["formulaire"],
            showAll: true,
          })
        }
      >
        {(data) => {
          return (
            <div className="grid c1 gap10 ">
              {data?.map((formulaire) => {
                return (
                  <Card
                    color="green"
                    key={uid()}
                    title={formulaire.name}
                    onClick={async () => {
                      await openFormulaireDialog(formulaire);
                    }}
                    onDelete={async () => {
                      await apiFetch("general", "deleteAny", {
                        id: formulaire.id,
                        table: "references",
                      });
                      setReload((prev) => prev + 1);
                    }}
                  >
                    <div className="gray">{formulaire.description}</div>
                    <div className="gray">
                      <Copyable str={formulaire.id || ""}></Copyable>
                    </div>
                  </Card>
                );
              })}
            </div>
          );
        }}
      </FetchableList>
    </CompartmentCard>
  );
}

function FormulaireChoiceList({
  onSelect,
}: {
  onSelect: (newValue: Reference) => void;
}) {
  const [reload, setReload] = useState(0);
  let [searchKey, setSearchKey] = useState("");

  async function openReferenceDialog(formulaire: Reference) {
    await openDrawer({
      id: "formulaireDialog",
      title: "Formulaire",

      content: (
        <ReferenceForm
          current={formulaire}
          categories={["formulaire"]}
          onChange={(newValue) => {
            formulaire = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        let result = await apiFetch("references", "addOne", {
          reference: formulaire,
        });
        if (!result) return;

        onSelect(result);
        setReload((prev) => prev + 1);
      },
    });
  }

  return (
    <div>
      <SearchBar
        placeholder="Rechercher un formulaire..."
        value={searchKey}
        onChange={(newValue) => {
          setSearchKey(newValue || "");
        }}
      ></SearchBar>
      <FetchableList
        queryKey={["FormulaireChoiceList", searchKey, reload]}
        queryFn={() =>
          apiFetch("references", "loadMany", {
            userId: getUserId(),
            searchKey,
            categoriesIds: [
              "formulaire",
              "exam",
              "imaging",
              "exploration",
              "biology",
            ],
            showAll: true,
          })
        }
        emptyChild={
          searchKey && (
            <div className="center grid c1 gap10 p20">
              Aucun formulaire disponible
              <Button
                onClick={async () => {
                  let formulaire: Reference = {
                    name: `${searchKey || ""}`,
                    creator: getUserId(),
                    sections: [],
                  };

                  await openReferenceDialog(formulaire);
                }}
              >
                Créer {searchKey}
              </Button>
            </div>
          )
        }
      >
        {(data) => (
          <div className="grid c1 gap10">
            {data?.map((formulaire, index) => {
              return (
                <Card
                  key={uid()}
                  color="green"
                  title={formulaire.name}
                  onClick={async () => {
                    onSelect(formulaire);
                  }}
                >
                  <div className="gray">{formulaire.category}</div>
                </Card>
              );
            })}
          </div>
        )}
      </FetchableList>
    </div>
  );
}

export { AdminFormulaires, FormulaireChoiceList };
